import { Link } from "react-router-dom";
import styles from "./styles/AuthSection.module.scss";

const AuthSection = () => {
  return (
    <div className={styles["auth-section"]}>
      <Link to={"/auth/login"} className={styles.login}>
        ورود
      </Link>

      <Link to={"/auth/signup"} className={styles.signup}>
        ثبت نام
      </Link>
    </div>
  );
};

export default AuthSection;
